export const MOTOR_FORMIK_KEYS = {
  EXISTINGPOLICYCLAIM: 'existingPolicyClaim',
  ISPOLICYEXPIRED: 'isPolicyExpired',
  POLICYTYPE: 'policyType',
  REGDATE: 'regDate',
  THIRDPAYTYDATE:
    'Third Party Start Date should be greater than Vehicle Registration Date',
  THIRDPARTYSTARTDATE: 'thirdPartyStartDate',
  THIRDPARTYGREATERTHANPREVPOLICY:
    'Third Party Expiry Date should be greater than Previous Policy Expiry Date',
  THIRDPARTYGREATERTHANSTARTDATE:
    'Third Party Expiry Date should be exactly 3 years more than Third Party Start Date',
  NCB: 'ncb',
  COMPANYNAME: 'companyName',
  ISCOMPANY: 'isCompany',
  PREVPOLICYNUMBER: 'previousPolicyNumber',
  PREVPOLICYPROVIDER: 'previousPolicyProvider',
  EMAIL: 'email',
  NAME: 'name',
  MOBILENUMBER: 'mobileNumber',
  THIRDPARTYEXPIREDDATE: 'thirdPartyExpiryDate',
  THIRDPARTYPROVIDER: 'thirdPartyProvider',
  THIRDPARTYPOLICYNO: 'thirdPartyPolicyNo',
  THIRDPARTYPROVIDERFIRSTNAME: 'thirdPartyProviderFirstName',
  EXPIRYDATE: 'expiryDate',
  EXPIREDDATE: 'expiredDate',
}

export const MOTOR_INS_FORMIK = {
  CAROWNEDBY: 'carOwnedBy',
  COMPANY: 'company',
  EXTERNALCNGLPGKIT: 'externalCngLpgKit',
  YES: 'yes',
  MIN_AMT_SHOULDBE: 'Minimum Amount Should be 10000',
  MAX_AMT_SHOULDBE: 'Maximum Amount Should be 50000',
  ISCURRENTCARLOAN: 'isCurrentCarLoan',
  AGE: 'age',
  MUST_BE18: 'Must be at least 18 years old',
  COMPANY_NAME: 'companyName',
  CITY: 'city',
  PINCODE: 'pincode',
  STATE: 'state',
  FIRSTNAME: 'firstName',
  COMPANY_INCORPORATION_DATE: 'companyIncorporationDate',
  ISCOMPANY: 'isCompany',
  COMPANYPAN: 'companyPan',
  COMPANY_GSTIN: 'companyGstin',
  MANUFACTURINGYEAR: 'manufacturingYear',
  NOMINEE_RELATION: 'nomineeRelation',
  LASTNAME: 'lastName',
  ISCURRENTLOAN: 'isCurrentCarLoan',
  CURRENTLOANPROVIDER: 'currentCarLoanProvider',
  ENGINENUMBER: 'engineNumber',
  CHASSISNUMBER: 'chassisNumber',
  MANUFACTURINGMONTH: 'manufacturingMonth',
}
